console.log("Load script.js");

// Footer - Slider for Company's Acheivement display
$(function () {
  $(".footer-content-slider").slick({
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 250,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Footer - Slider for Technical Expertiese

  $(".technical-slic").slick({
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 4,
    // dots: true,
    infinite: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 250,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// Initialize and add the map

function initMap() {
  var center = new google.maps.LatLng(18.592138720467293, 73.75550370911787);
  var map = new google.maps.Map(document.getElementById("map"), {
    zoom: 11,
    center: center,
    disableDefaultUI: true,
    backgroundColor: "none",
    styles: [
      { elementType: "geometry", stylers: [{ color: "#333333" }] },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#222222" }],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ color: "#eeeeee" }],
      },
      {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#eeeeee" }],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#3a3a3a" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ color: "#777777" }],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#212121" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#555555" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#222222" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ color: "#f3d19c" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#bbbbbb" }],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#777777" }],
      },
      {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#222222" }],
      },
    ],
  });
  // var svgMarker = {
  //   path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
  //   fillColor: "red",
  //   fillOpacity: 0.6,
  //   anchor: new google.maps.Point(0, 0),
  //   strokeWeight: 0,
  //   scale: 1,
  // };
  new google.maps.Marker({
    position: map.getCenter(),
    // icon: "./assets/images/logo_sym.png",
    icon: {
      url: "./assets/images/logo_sym.png",
      scaledSize: new google.maps.Size(60, 50),
    },
    Animation: "DROP",
    map: map,
  });
}
window.initMap = initMap;

// Slider for Testimonials

const buttons = document.querySelectorAll("[data-carousel-button]");
buttons.forEach((button) => {
  button.addEventListener("click", () => {
    const offset = button.dataset.carouselButton === "next" ? 1 : -1;
    const slides = button
      .closest("[data-carousel]")
      .querySelector("[data-slides]");

    const activeSlide = slides.querySelector("[data-active]");
    const activeIndex = Array.from(slides.children).indexOf(activeSlide);
    let newIndex = activeIndex + offset;

    if (newIndex < 0) {
      newIndex = slides.children.length - 1;
    } else if (newIndex >= slides.children.length) {
      newIndex = 0;
    }

    activeSlide.removeAttribute("data-active");
    slides.children[newIndex].setAttribute("data-active", "true");
  });
});

// Service Section - Tab Animation

function openService(evt, serviceName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(serviceName).style.display = "block";

  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen").click();

// Hamburger menu
const hamburgerBtn = document.querySelector("#btnHamburger");
const header = document.querySelector(".header");
const overlay = document.querySelector(".overlay");
const fadeElems = document.querySelectorAll(".has-fade");

hamburgerBtn.addEventListener("click", () => {
  if (header.classList.contains("open")) {
    header.classList.remove("open");
    fadeElems.forEach((elem) => {
      elem.classList.remove("fade-in");
      elem.classList.add("fade-out");
    });
  } else {
    header.classList.add("open");
    fadeElems.forEach((elem) => {
      elem.classList.remove("fade-out");
      elem.classList.add("fade-in");
    });
  }
});

// Hero section video for mobile
var video = document.getElementById("heroVideo");
console.log(video);
var WindowWidth = window.innerWidth;

if (WindowWidth < 425) {
  //It is a small screen
  video.innerHTML +=
    "<source src='./assets/videos/intro-mobile.mp4' type='video/mp4'>";
} else {
  //It is a big screen or desktop
  video.innerHTML +=
    "<source src='./assets/videos/intro-desktop.mp4' type='video/mp4'>";
}
